import { DateTime } from 'luxon';

import type { CalendarEventWithColor, LogFormDefaults } from '../types';

import { extractTaskKey } from './extractTaskKey';

/**
 * Build pre-filled form defaults from a calendar event.
 */
export const buildLogFormDefaults = (event: CalendarEventWithColor): LogFormDefaults => {
  const start = DateTime.fromISO(event.startsAt);
  const end = DateTime.fromISO(event.endsAt);
  const diffMinutes = end.diff(start, 'minutes').minutes;

  const hours = Math.floor(diffMinutes / 60);
  const minutes = Math.round(diffMinutes % 60);
  const durationParts: string[] = [];
  if (hours > 0) durationParts.push(`${hours}ч`);
  if (minutes > 0) durationParts.push(`${minutes}м`);
  const duration = durationParts.join(' ') || '0м';

  const dateFormatted = start.setLocale('ru').toLocaleString(DateTime.DATE_SHORT);
  const timeFormatted = start.setZone('Europe/Moscow').toFormat('HH:mm');

  return {
    startDate: start.toISODate(),
    startTime: start.toFormat('HH:mm'),
    duration,
    comment: `Отмечено время за встречу "${event.summary}" ${dateFormatted} // начало: ${timeFormatted}`,
    taskKey: extractTaskKey(event.description),
  };
};
